import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronsUpDown, Plus } from "lucide-react";

const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const accentFilter = (value, search) => (norm(value).includes(norm(search)) ? 1 : 0);

// items: [{ value, search, render, disabled }]
export const SearchCombobox = ({ items, value, onChange, placeholder, searchPlaceholder = "Digite para buscar...", emptyText = "Nada encontrado", testId, selectedLabel, onCreate, createLabel }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const pick = (v) => { onChange(v); setOpen(false); setQuery(""); };
  const q = norm(query.trim());
  const exact = items.some((it) => norm(it.search).split(/\s+/).includes(q) || norm(it.label) === q);
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} data-testid={testId}
          className="flex h-9 w-full items-center justify-between rounded-sm border border-input bg-transparent px-3 py-2 text-sm shadow-sm text-left">
          <span className={`truncate ${value ? "" : "text-muted-foreground"}`}>{value ? selectedLabel : placeholder}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[280px]" align="start">
        <Command filter={accentFilter}>
          <CommandInput placeholder={searchPlaceholder} value={query} onValueChange={setQuery} data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>{onCreate && query.trim() ? "Nenhuma cadastrada com esse nome" : emptyText}</CommandEmpty>
            <CommandGroup>
              {items.map((it) => (
                <CommandItem key={it.value} value={it.search} disabled={it.disabled} onSelect={() => pick(it.value)} data-testid={`${testId}-option-${it.value}`}>
                  <Check className={`w-4 h-4 mr-2 ${value === it.value ? "opacity-100" : "opacity-0"}`} />
                  {it.render}
                </CommandItem>
              ))}
            </CommandGroup>
            {onCreate && q && !exact && (
              <CommandGroup heading="Não encontrou?">
                <CommandItem value={`__create__ ${query}`} onSelect={() => { onCreate(query.trim()); setOpen(false); setQuery(""); }} data-testid={`${testId}-create`}>
                  <Plus className="w-4 h-4 mr-2 text-orange-500" /> {createLabel ? createLabel(query.trim()) : `Usar "${query.trim()}"`}
                </CommandItem>
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
